"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogActions.default;
  }
});

var _DialogActions = _interopRequireDefault(require("./DialogActions"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/DialogActions/index.js
// module id = 458
// module chunks = 0